import { toast } from "react-hot-toast";

const checkValidate = (selectedFile) => {
  if (!selectedFile?.name?.endsWith('.csv') && !selectedFile?.name?.endsWith('.kml')
    && !selectedFile?.name?.endsWith('.kml.gz')) {
    toast.error("Допустимые форматы только .csv,.kml,.kml.gz, выберите другой файл");
    return false;
  }

  if (selectedFile.size > 10 * 1024 * 1024) {
    toast.error("Лимит превышен. Файл должен быть не более 10 МБ.");
    return false;
  }

  return true;
};

export default checkValidate;
